import { render, staticRenderFns } from "./RiskAnalysisUnit.vue?vue&type=template&id=183667a7&scoped=true"
import script from "./RiskAnalysisUnit.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisUnit.vue?vue&type=script&lang=js"
import style0 from "./RiskAnalysisUnit.vue?vue&type=style&index=0&id=183667a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183667a7",
  null
  
)

export default component.exports